/**
 * M75 机甲：未改键 `getKeyboardKeys` 样例（layer0）→ 布局 HID / 分位值 → `pos`。
 * 与 `KEYBOARD_LAYOUTS.m75` 虚拟键盘回显、改键/灯光 pos 解析一致。
 */
const CB_VALUE_TO_HID: Readonly<Record<number, number>> = {
  65536: 224,
  131072: 225,
  262144: 226,
  524288: 227,
  1048576: 228,
  2097152: 229,
  4194304: 230,
  218103808: 61697,
};

/** 设备上报的 [value, pos]；来自 M75 实机 getKeyboardKeys({ layer: 0 }) */
const M75_INIT_VALUE_POS: ReadonlyArray<readonly [number, number]> = [
  [41, 8],
  [53, 12],
  [43, 16],
  [57, 20],
  [131072, 24],
  [65536, 28],
  [58, 32],
  [30, 36],
  [20, 40],
  [4, 44],
  [29, 48],
  [524288, 52],
  [59, 56],
  [31, 60],
  [26, 64],
  [22, 68],
  [27, 72],
  [262144, 76],
  [60, 80],
  [32, 84],
  [8, 88],
  [7, 92],
  [6, 96],
  [0, 100],
  [61, 104],
  [33, 108],
  [21, 112],
  [9, 116],
  [25, 120],
  [0, 124],
  [62, 128],
  [34, 132],
  [23, 136],
  [10, 140],
  [5, 144],
  [44, 148],
  [63, 152],
  [35, 156],
  [28, 160],
  [11, 164],
  [17, 168],
  [0, 172],
  [64, 176],
  [36, 180],
  [24, 184],
  [13, 188],
  [16, 192],
  [0, 196],
  [65, 200],
  [37, 204],
  [12, 208],
  [14, 212],
  [54, 216],
  [4194304, 220],
  [66, 224],
  [38, 228],
  [18, 232],
  [15, 236],
  [55, 240],
  [218103808, 244],
  [67, 248],
  [39, 252],
  [19, 256],
  [51, 260],
  [56, 264],
  [1048576, 268],
  [68, 272],
  [45, 276],
  [47, 280],
  [52, 284],
  [0, 288],
  [0, 292],
  [69, 296],
  [46, 300],
  [48, 304],
  [50, 308],
  [100, 312],
  [0, 316],
  [72, 320],
  [42, 324],
  [49, 328],
  [40, 332],
  [2097152, 336],
  [80, 340],
  [0, 344],
  [0, 348],
  [0, 352],
  [0, 356],
  [82, 360],
  [81, 364],
  [117440541, 368],
  [73, 372],
  [76, 376],
  [75, 380],
  [78, 384],
  [79, 388],
  [0, 392],
  [0, 396],
  [0, 400],
  [0, 404],
  [0, 408],
  [0, 412],
  [0, 416],
  [0, 420],
  [0, 424],
  [0, 428],
  [0, 432],
  [0, 436],
  [0, 440],
  [0, 444],
  [0, 448],
  [0, 452],
  [0, 456],
  [0, 460],
  [0, 464],
  [0, 468],
  [0, 472],
  [0, 476],
  [0, 480],
  [0, 484],
  [0, 488],
  [0, 492],
  [0, 496],
  [0, 500],
  [0, 504],
  [0, 508],
];

/** M75 旋钮出厂 value（与 UI 码 8418 对应） */
export const M75_KNOB_DEVICE_VALUE = 117440541 as const;

function buildM75FactoryPosByKeycode(): Readonly<Record<number, number>> {
  const o: Record<number, number> = {};
  for (const [value, pos] of M75_INIT_VALUE_POS) {
    const hid = CB_VALUE_TO_HID[value] ?? value;
    o[hid] = pos;
  }
  /** 与 `KEYBOARD_LAYOUTS.m75` 旋钮虚拟码一致 */
  o[8418] = 368;
  return o;
}

export const M75_FACTORY_POS_BY_KEYCODE: Readonly<Record<number, number>> =
  buildM75FactoryPosByKeycode();
